div {
  margin: auto;
}

div > svg {
  fill: var(--color-button-secondary);
}
div > svg:hover {
  fill: var(--color-button-secondary-hover);
  cursor: pointer;
}

.sm, .small, .small > svg {
  width: 14px;
  height: 14px;
}

.md, .medium, .medium > svg {
  width: 24px;
  height: 24px;
}

.lg, .large, .large > svg {
  width: 62px;
  height: 62px;
}

 div.disabled svg {
  fill: #999999;
  cursor: not-allowed;
}